export const mockData = {
    users: [
        { 
            id: 1, 
            name: "Alice Johnson", 
            email: "alice@admin.com", 
            phone: "+971 50 123 4567",
            role: "Super Admin", 
            hotel: "Grand Azure", 
            assignedProperties: [1, 2, 3],
            status: "Active", 
            employeeId: "SA-001",
            department: "Administration",
            joiningDate: "2023-01-15",
            lastLogin: "2026-05-11T08:30:00Z",
            mfaEnabled: true,
            permissions: ["view_dashboard", "manage_users", "manage_hotels", "view_reports", "manage_permissions"],
            activityLog: [
                { action: "Login", module: "Auth", target: "System", timestamp: "2026-05-11T08:30:00Z", ip: "192.168.1.10" },
                { action: "Created User", module: "Users", target: "Bob Martinez", timestamp: "2026-05-10T14:20:00Z", ip: "192.168.1.10" },
            ]
        },
        { 
            id: 2, 
            name: "Bob Martinez", 
            email: "bob@admin.com", 
            phone: "+960 777 8899",
            role: "Manager", 
            hotel: "Blue Horizon", 
            assignedProperties: [2],
            status: "Active", 
            employeeId: "MGR-202",
            department: "Operations",
            joiningDate: "2023-06-01",
            lastLogin: "2026-05-10T18:45:00Z",
            mfaEnabled: false,
            permissions: ["view_dashboard", "view_reports"],
            activityLog: [
                { action: "Login", module: "Auth", target: "System", timestamp: "2026-05-10T18:45:00Z", ip: "192.168.2.15" },
            ]
        },
        { id: 3, name: "Carol Smith", email: "carol@admin.com", role: "Receptionist", hotel: "Grand Azure", status: "Inactive", lastLogin: "2026-04-20T10:00:00Z" },
        { id: 4, name: "David Lee", email: "david@admin.com", role: "Manager", hotel: "The Pinnacle", status: "Active", lastLogin: "2026-05-11T09:15:00Z" },
        { id: 5, name: "Eva Chen", email: "eva@admin.com", role: "Auditor", hotel: "Blue Horizon", status: "Active", lastLogin: "2026-05-10T16:00:00Z" },
    ],
    permissions: [
        { id: 1, name: "view_dashboard", description: "Access the main dashboard", level: "Read", roles: ["Super Admin", "Manager", "Receptionist", "Auditor"] },
        { id: 2, name: "manage_users", description: "Create, edit and delete users", level: "Write", roles: ["Super Admin", "Manager"] },
        { id: 3, name: "manage_hotels", description: "Add, update and remove hotels", level: "Write", roles: ["Super Admin"] },
        { id: 4, name: "view_reports", description: "View analytics and reports", level: "Read", roles: ["Super Admin", "Auditor"] },
        { id: 5, name: "manage_permissions", description: "Grant or revoke access rights", level: "Admin", roles: ["Super Admin"] },
    ],
    hotels: [
        { 
            id: 1, 
            name: "Grand Azure", 
            location: "Dubai, UAE", 
            rooms: 320, 
            rating: 4.8, 
            status: "Active", 
            manager: "Alice Johnson",
            settings: {}
        },
        { id: 2, name: "Blue Horizon", location: "Maldives", rooms: 180, rating: 4.6, status: "Active", manager: "Bob Martinez" },
        { id: 3, name: "The Pinnacle", location: "Paris, France", rooms: 250, rating: 4.9, status: "Active", manager: "David Lee" },
    ],
    roles: [
        { name: "Super Admin", description: "Full access to all modules and properties." },
        { name: "Hotel Admin", description: "Manage specific hotel operations and staff." },
        { name: "Manager", description: "Oversee daily hotel activities and reports." },
        { name: "Receptionist", description: "Manage bookings, check-ins, and check-outs." },
        { name: "Accountant", description: "Manage finance and audit reports." },
        { name: "Auditor", description: "Review system logs and financial accuracy." },
    ],
    dashboard: {
        occupancy: {
            rate: 84,
            trend: "up",
            trendValue: 5.2,
            occupied: 126,
            total: 150,
            arrivals: 24,
            departures: 18,
            pendingCheckins: 6
        },
        revenue: {
            today: 12450.00,
            todayTrend: 8.5,
            outstandingDues: 3200.00,
            overdueCount: 4,
            monthToDate: 145200.00,
            monthTrend: 12.3
        },
        roomStatus: {
            clean: 85,
            cleaning: 12,
            repair: 5,
            ooo: 8,
            occupied: 126,
            vacant: 24,
            total: 150
        },
        reservations: {
            newBookings: { count: 32, trend: 15 },
            checkins: { count: 24, trend: 5 },
            checkouts: { count: 18, trend: -2 },
            cancellations: { count: 3, trend: 10 }
        },
        housekeeping: {
            ready: 85,
            inProgress: 12,
            dirty: 25,
            ooo: 8,
            businessCritical: 4
        },
        staffOnDuty: {
            total: 12,
            required: 15,
            departments: [
                { name: "Front Desk", count: 3, required: 4, status: "understaffed" },
                { name: "Housekeeping", count: 5, required: 6, status: "understaffed" },
                { name: "Restaurant", count: 2, required: 3, status: "ok" },
                { name: "Maintenance", count: 2, required: 2, status: "ok" }
            ]
        },
        alerts: [
            { id: 1, type: "Critical", description: "Night Audit failed for Property A", timestamp: "2026-05-11T03:15:00Z", status: "Unresolved" },
            { id: 2, type: "Warning", description: "Low inventory for Housekeeping supplies", timestamp: "2026-05-11T07:45:00Z", status: "Unresolved" },
            { id: 3, type: "Info", description: "System update scheduled for 02:00 AM", timestamp: "2026-05-10T22:00:00Z", status: "Resolved" }
        ],
        performance: [
            { day: "Mon", occ: 75, rev: 8500 },
            { day: "Tue", occ: 78, rev: 9200 },
            { day: "Wed", occ: 82, rev: 10500 },
            { day: "Thu", occ: 80, rev: 9800 },
            { day: "Fri", occ: 88, rev: 13000 },
            { day: "Sat", occ: 95, rev: 15500 },
            { day: "Sun", occ: 84, rev: 12450 }
        ],
        nightAudit: {
            lastAudit: "2026-05-11T03:15:00Z",
            status: "Failed"
        },
        recentActivity: [
            { action: "Check-in", actor: "Carol Smith", role: "Receptionist", target: "Room 102", timestamp: "10 mins ago" },
            { action: "Room Status Change", actor: "John Doe", role: "Housekeeping", target: "Room 205 (Dirty -> Clean)", timestamp: "25 mins ago" },
            { action: "New Booking", actor: "System", role: "Engine", target: "Guest: Sarah Connor", timestamp: "45 mins ago" },
            { action: "Payment Received", actor: "Bob Martinez", role: "Manager", target: "450.00 (Inv #882)", timestamp: "1 hour ago" }
        ]
    },
    roomTypes: [
        { id: 1, name: "Deluxe Room", description: "Spacious room with city view", baseRate: 150, maxAdults: 2, maxKids: 1, status: "Active" },
        { id: 2, name: "Executive Suite", description: "Premium suite with separate lounge", baseRate: 350, maxAdults: 3, maxKids: 2, status: "Active" },
        { id: 3, name: "Standard Room", description: "Comfortable room for budget travelers", baseRate: 100, maxAdults: 2, maxKids: 0, status: "Active" },
        { id: 4, name: "Presidential Suite", description: "Ultimate luxury with private terrace", baseRate: 800, maxAdults: 4, maxKids: 2, status: "Active" }
    ],
    floors: [
        { id: 1, number: 1, label: "1st Floor" },
        { id: 2, number: 2, label: "2nd Floor" },
        { id: 3, number: 3, label: "3rd Floor" },
        { id: 4, number: 4, label: "4th Floor" }
    ],
    wings: [
        { id: 1, name: "North Wing" },
        { id: 2, name: "South Wing" },
        { id: 3, name: "East Wing" },
        { id: 4, name: "West Wing" }
    ],
    amenities: [
        { id: 1, name: "High-Speed WiFi", type: "In-Room Tech" },
        { id: 2, name: "Mini Bar", type: "Minibar" },
        { id: 3, name: "Smart TV", type: "In-Room Tech" },
        { id: 4, name: "King Size Bed", type: "Bedding" },
        { id: 5, name: "Ocean View", type: "View" },
        { id: 6, name: "Rain Shower", type: "Bathroom" }
    ],
    rooms: [
        { id: 1, roomNumber: "101", floor: 1, wing: "North", type: "Standard Room", occupancy: "2+0", rate: 100, status: "Clean", features: ["WiFi", "TV"] },
        { id: 2, roomNumber: "102", floor: 1, wing: "North", type: "Deluxe Room", occupancy: "2+1", rate: 150, status: "Occupied", features: ["WiFi", "TV", "Minibar"] },
        { id: 3, roomNumber: "201", floor: 2, wing: "South", type: "Executive Suite", occupancy: "3+2", rate: 350, status: "Cleaning", features: ["WiFi", "TV", "Minibar", "Ocean View"] },
        { id: 4, roomNumber: "305", floor: 3, wing: "East", type: "Deluxe Room", occupancy: "2+1", rate: 150, status: "Repair", features: ["WiFi", "TV"] },
        { id: 5, roomNumber: "401", floor: 4, wing: "West", type: "Presidential Suite", occupancy: "4+2", rate: 800, status: "Out of Order", features: ["All Features"] },
        { id: 6, roomNumber: "105", floor: 1, wing: "South", type: "Standard Room", occupancy: "2+0", rate: 100, status: "Clean", features: ["WiFi"] },
    ],
    maintenance: [
        { id: 1, room: "401", startDate: "2026-05-10", endDate: "2026-05-15", reason: "AC Refurbishment", status: "In Progress" },
        { id: 2, room: "305", startDate: "2026-05-11", endDate: "2026-05-12", reason: "Plumbing Leak", status: "Scheduled" }
    ],
    inventoryTemplates: [
        { roomType: "Standard Room", items: [{ name: "Bed", qty: 1 }, { name: "Chair", qty: 1 }, { name: "TV", qty: 1 }] },
        { roomType: "Deluxe Room", items: [{ name: "King Bed", qty: 1 }, { name: "Sofa", qty: 1 }, { name: "Mini Fridge", qty: 1 }] }
    ],
    ratePlans: [
        { id: 1, name: "Standard Daily Rate", roomType: "Standard Room", channel: "Direct", rate: 100, type: "Base", status: "Active", validFrom: "2026-01-01", validTo: "2026-12-31" },
        { id: 2, name: "Summer Special 2026", roomType: "Deluxe Room", channel: "OTA", rate: 120, type: "Seasonal", status: "Active", validFrom: "2026-06-01", validTo: "2026-08-31", priority: 1 },
        { id: 3, name: "Corporate - TechCorp", roomType: "Executive Suite", channel: "Corp.", rate: 280, type: "Corporate", status: "Active", validFrom: "2026-01-01", validTo: "2026-12-31" },
        { id: 4, name: "Flash Sale - 20% OFF", roomType: "All", channel: "All", rate: 20, type: "Promotional", modifier: "Percentage", promoCode: "FLASH20", status: "Inactive", validFrom: "2026-05-15", validTo: "2026-05-20" }
    ],
    operationalFees: {
        earlyCheckin: { type: "Fixed", amount: 30, thresholdTime: "10:00" },
        lateCheckout: { type: "Percentage", amount: 50, thresholdTime: "15:00" }
    },
    guests: [
        { id: 1, name: "John Smith", email: "john@example.com", phone: "+1 234 567 890", identity: "Passport: A1234567", country: "USA", status: "VIP" },
        { id: 2, name: "Sarah Connor", email: "sarah@example.com", phone: "+1 987 654 321", identity: "DL: TX-9988", country: "Canada", status: "Repeat" },
    ],
    reservations: [
        { id: "RES-001", guestName: "John Smith", type: "Single", rooms: ["101"], checkIn: "2026-05-11", checkOut: "2026-05-14", nights: 3, status: "Checked-in", payment: "Paid", source: "Direct", totalAmount: 300 },
        { id: "RES-002", guestName: "Sarah Connor", type: "Single", rooms: ["201"], checkIn: "2026-05-12", checkOut: "2026-05-15", nights: 3, status: "Confirmed", payment: "Partial", source: "OTA", totalAmount: 450 },
        { id: "GRP-101", guestName: "TechCorp Event", type: "Group", rooms: ["102", "105"], checkIn: "2026-05-13", checkOut: "2026-05-16", nights: 3, status: "Confirmed", payment: "Unpaid", source: "Corp.", totalAmount: 1200 },
        { id: "RES-003", guestName: "Michael Scott", type: "Single", rooms: ["101"], checkIn: "2026-05-15", checkOut: "2026-05-17", nights: 2, status: "Cancelled", payment: "Refunded", source: "Direct", totalAmount: 200 }
    ],
    groups: [
        { id: "GRP-101", name: "TechCorp Annual Meet", organiser: "Alice Finance", guestCount: 15, roomsAllocated: 8, status: "Confirmed" }
    ],
    transactions: [
        { id: "TX-901", resId: "RES-001", amount: 300, method: "Credit Card", type: "Payment", timestamp: "2026-05-11T09:00:00Z" },
        { id: "TX-902", resId: "RES-003", amount: 180, method: "Refund", type: "Refund", timestamp: "2026-05-10T14:00:00Z" }
    ],
    housekeepingTasks: [
        { id: "HK-101", room: "101", type: "Deep Clean", priority: "High", assignedTo: "Mary Jane", startedAt: "2026-05-11T08:00:00Z", dueBy: "2026-05-11T10:00:00Z", status: "In Progress" },
        { id: "HK-102", room: "201", type: "Standard Clean", priority: "Medium", assignedTo: "John Doe", startedAt: null, dueBy: "2026-05-11T12:00:00Z", status: "Pending" },
        { id: "HK-103", room: "305", type: "Maintenance Repair", priority: "Urgent", assignedTo: "Steve Smith", startedAt: "2026-05-11T09:30:00Z", dueBy: "2026-05-11T10:30:00Z", status: "In Progress" }
    ],
    lostAndFound: [
        { id: "LF-001", item: "Gold Watch", room: "102", foundDate: "2026-05-10", foundBy: "Mary Jane", location: "Safe Box 1", status: "Found" },
        { id: "LF-002", item: "Phone Charger", room: "205", foundDate: "2026-05-09", foundBy: "John Doe", location: "Front Desk", status: "Claimed" }
    ],
    housekeepingStats: {
        totalTasks: 24,
        completed: 18,
        inProgress: 4,
        overdue: 2,
        slaCompliance: 92
    },
    menuCategories: [
        { id: 1, name: "Breakfast", icon: "EggAlt", order: 1 },
        { id: 2, name: "Appetizers", icon: "Fastfood", order: 2 },
        { id: 3, name: "Main Course", icon: "Restaurant", order: 3 },
        { id: 4, name: "Desserts", icon: "Cake", order: 4 },
        { id: 5, name: "Beverages", icon: "LocalBar", order: 5 }
    ],
    menuItems: [
        { id: 1, name: "Eggs Benedict", category: "Breakfast", price: 18.5, description: "Poached eggs with hollandaise sauce", status: "Available", prepTime: 15, tags: ["Vegetarian"] },
        { id: 2, name: "Truffle Pasta", category: "Main Course", price: 32.0, description: "Homemade pasta with black truffle cream", status: "Available", prepTime: 25, tags: ["Signature"] },
        { id: 3, name: "Chocolate Fondant", category: "Desserts", price: 12.0, description: "Lava cake with vanilla bean ice cream", status: "Out of Stock", prepTime: 20, tags: ["Sweet"] }
    ],
    restaurantOrders: [
        { id: "ORD-501", table: "T-12", room: "102", guestName: "John Smith", time: "2026-05-11T12:30:00Z", items: "Truffle Pasta x2, Wine x1", amount: 85.0, status: "In Progress" },
        { id: "ORD-502", table: "Room Service", room: "201", guestName: "Sarah Connor", time: "2026-05-11T13:00:00Z", items: "Eggs Benedict x1, Coffee x2", amount: 28.5, status: "Completed" }
    ],
    restaurantTables: [
        { id: 1, number: "T-10", section: "Window", capacity: 2, status: "Vacant" },
        { id: 2, number: "T-11", section: "Main Hall", capacity: 4, status: "Occupied" },
        { id: 3, number: "T-12", section: "Main Hall", capacity: 4, status: "Occupied" }
    ],
    inventoryItems: [
        { id: 1, name: "Bath Soap (100g)", category: "Housekeeping", department: "Operations", unit: "Pcs", stock: 450, reorderLevel: 100, maxStock: 1000, status: "Active", unitCost: 0.5 },
        { id: 2, name: "Premium Bed Linen (King)", category: "Linen", department: "Operations", unit: "Set", stock: 45, reorderLevel: 50, maxStock: 200, status: "Active", unitCost: 45.0 },
        { id: 3, name: "Arabic Coffee Beans (1kg)", category: "F&B", department: "Restaurant", unit: "Bag", stock: 12, reorderLevel: 15, maxStock: 50, status: "Active", unitCost: 28.0 }
    ],
    purchaseOrders: [
        { id: "PO-2026-001", supplier: "Global Linens Ltd", items: "Premium Bed Linen x20", total: 900.0, date: "2026-05-10", status: "Submitted" },
        { id: "PO-2026-002", supplier: "Horeca Supplies", items: "Arabic Coffee Beans x10", total: 280.0, date: "2026-05-11", status: "Approved" }
    ],
    suppliers: [
        { id: 1, name: "Global Linens Ltd", contact: "Mark Reed", email: "orders@globallinens.com", phone: "+971 4 888 1122", category: "Linen", status: "Active" },
        { id: 2, name: "Horeca Supplies", contact: "Fatima Ali", email: "sales@horeca.com", phone: "+971 4 999 3344", category: "F&B", status: "Active" }
    ],
    inventoryStats: {
        totalItems: 145,
        lowStock: 12,
        outOfStock: 3,
        pendingPOs: 5
    },
    expenses: [
        { id: "EXP-001", date: "2026-05-10", category: "Utility", description: "DEWA Electricity Bill", amount: 1250.0, method: "Bank Transfer", status: "Paid" },
        { id: "EXP-002", date: "2026-05-11", category: "Maintenance", description: "AC Spare Parts", amount: 450.0, method: "Cash", status: "Paid" }
    ],
    revenueCategories: ["Room Revenue", "F&B", "Laundry", "SPA", "Other"],
    expenseCategories: ["Utility", "Salary", "Maintenance", "Marketing", "F&B Cost", "Other"],
    auditHistory: [
        { id: "AUD-101", date: "2026-05-10", runBy: "Alice Johnson", status: "Success", revenue: 15400.0, payments: 12000.0 },
        { id: "AUD-102", date: "2026-05-09", runBy: "Alice Johnson", status: "Success", revenue: 14200.0, payments: 11500.0 }
    ],

    otaChannels: [
        { id: 1, name: "Booking.com", status: "Connected", lastSync: "2026-05-11T14:30:00Z", bookingsToday: 5, error: null },
        { id: 2, name: "Expedia", status: "Connected", lastSync: "2026-05-11T14:15:00Z", bookingsToday: 3, error: null },
        { id: 3, name: "Airbnb", status: "Error", lastSync: "2026-05-10T22:00:00Z", bookingsToday: 0, error: "API Key Expired" }
    ],
    otaBookingsLog: [
        { id: "OTA-771", channel: "Booking.com", guest: "Robert Brown", roomType: "Deluxe Room", checkIn: "2026-05-12", status: "Imported" },
        { id: "OTA-772", channel: "Expedia", guest: "Linda White", roomType: "Standard Room", checkIn: "2026-05-13", status: "Imported" },
        { id: "OTA-773", channel: "Airbnb", guest: "James Wilson", roomType: "Deluxe Room", checkIn: "2026-05-14", status: "Failed", error: "Room type mismatch" }
    ],
    channelPerformance: [
        { name: "Booking.com", bookings: 145, revenue: 22000, adr: 151, revpar: 125 },
        { name: "Expedia", bookings: 98, revenue: 15400, adr: 157, revpar: 110 },
        { name: "Direct", bookings: 210, revenue: 35000, adr: 166, revpar: 145 }
    ],
    reportCategories: [
        { id: 1, name: "Occupancy & Revenue", reports: ["Daily Occupancy", "Revenue Forecast", "RevPAR Analysis"] },
        { id: 2, name: "Reservations", reports: ["Arrivals List", "Departures List", "Cancellations"] },
        { id: 3, name: "Finance", reports: ["P&L Statement", "Expense Report", "Tax Summary"] },
        { id: 4, name: "Inventory", reports: ["Stock Levels", "Reorder Report", "Consumption"] }
    ],
    scheduledReports: [
        { id: 1, name: "Weekly Revenue Summary", frequency: "Weekly", nextRun: "2026-05-18", recipients: "alice@admin.com", status: "Active" },
        { id: 2, name: "Daily Arrivals", frequency: "Daily", nextRun: "2026-05-12", recipients: "reception@hotel.com", status: "Active" }
    ],
    reportHistory: [
        { id: "RPT-1001", name: "April P&L Report", type: "Financial", date: "2026-05-01", runBy: "Alice Johnson", format: "PDF" },
        { id: "RPT-1002", name: "Q1 Occupancy Analysis", type: "Operational", date: "2026-04-15", runBy: "Bob Martinez", format: "Excel" }
    ],
    notifications: [
        { id: 1, type: "Critical", title: "Housekeeping Overdue", message: "Room 102 cleaning has exceeded SLA by 45 mins.", timestamp: "2026-05-11T14:50:00Z", read: false, link: "/housekeeping" },
        { id: 2, type: "Warning", title: "Low Stock Alert", message: "Soap Bars (100g) dropped below threshold (50 units).", timestamp: "2026-05-11T14:45:00Z", read: false, link: "/inventory" },
        { id: 3, type: "Info", title: "New Reservation", message: "New booking received from Booking.com for Sarah Connor.", timestamp: "2026-05-11T14:40:00Z", read: true, link: "/reservations" }
    ],
    emailTemplates: [
        { id: 1, name: "Booking Confirmation", subject: "Reservation Confirmed at {{hotel_name}}", lastUpdated: "2026-05-01", status: "Active" },
        { id: 2, name: "Check-in Welcome", subject: "Welcome to {{hotel_name}}, {{guest_name}}!", lastUpdated: "2026-04-20", status: "Active" },
        { id: 3, name: "Post-Stay Survey", subject: "How was your stay at {{hotel_name}}?", lastUpdated: "2026-05-05", status: "Inactive" }
    ],
    alertRules: [
        { id: 1, name: "Inventory Threshold", trigger: "Stock < Threshold", channels: ["In-App", "Email"], status: "Enabled" },
        { id: 2, name: "Housekeeping SLA", trigger: "Task Time > 60m", channels: ["In-App"], status: "Enabled" }
    ]
};

export const getStats = () => {
    return {
        totalUsers: mockData.users.length,
        activeHotels: mockData.hotels.filter(h => h.status === 'Active').length,
        totalPermissions: mockData.permissions.length,
        ...mockData.dashboard.reservations, // Adding these for dashboard stats
        totalBookings: mockData.dashboard.reservations.newBookings.count,
        totalReservations: mockData.dashboard.reservations.checkins.count + mockData.dashboard.reservations.pendingCheckins // wait, checkins vs reservations
    };
};
